module.exports = __webpack_public_path__ + "static/media/exfile.6120d513.svg";